import { Link } from "react-router-dom";
import { useSyncStatus, statusLabel } from "@/offline/useSyncStatus";
import { Wifi, WifiOff, CloudUpload, CircleDashed } from "lucide-react";

const KIND_STYLES = {
  green: "bg-emerald-50 text-emerald-700 border-emerald-200",
  amber: "bg-amber-50 text-amber-700 border-amber-200",
  blue:  "bg-sky-50 text-sky-700 border-sky-200",
  red:   "bg-red-50 text-red-700 border-red-200",
  gray:  "bg-neutral-100 text-neutral-600 border-neutral-200",
};

const KIND_ICONS = {
  green: Wifi,
  amber: CloudUpload,
  blue:  CloudUpload,
  red:   WifiOff,
  gray:  CircleDashed,
};

export default function SyncPill({ dense = false }) {
  const s = useSyncStatus();
  const label = statusLabel(s);
  const Icon = KIND_ICONS[label.kind];
  return (
    <Link
      to="/sync"
      data-testid="sync-pill"
      data-sync-kind={label.kind}
      className={`inline-flex items-center gap-1.5 border rounded-full font-medium ${
        dense ? "text-[11px] px-2 py-1" : "text-xs px-2.5 py-1"
      } ${KIND_STYLES[label.kind]} hover:opacity-90 transition`}
      title={label.text}
    >
      <Icon className={dense ? "h-3 w-3" : "h-3.5 w-3.5"} />
      <span data-testid="sync-pill-text">{label.text}</span>
    </Link>
  );
}
